// Shared password policy used across every registration / password-change
// flow on the platform (BlueZone self-register, GreenZone, Supplier,
// Contractor, OnboardingWizard set-password, Customer profile change, …).
//
// Keep this file as the ONE source of truth for password rules.

export const checkPasswordRules = (pwd) => {
  const p = pwd || '';
  return {
    length:    p.length >= 8,
    uppercase: /[A-Z]/.test(p),
    lowercase: /[a-z]/.test(p),
    number:    /[0-9]/.test(p),
    special:   /[^A-Za-z0-9]/.test(p),
  };
};

export const isPasswordValid = (pwd) =>
  Object.values(checkPasswordRules(pwd)).every(Boolean);

export const passwordRuleLabels = (tr) => ({
  length:    tr ? 'En az 8 karakter' : 'Min 8 characters',
  uppercase: tr ? 'Büyük harf'        : 'Uppercase letter',
  lowercase: tr ? 'Küçük harf'        : 'Lowercase letter',
  number:    tr ? 'Rakam'             : 'Number',
  special:   tr ? 'Özel karakter'     : 'Special character',
});
